export class PaymentRequests {
    id: number;
    clientRequestId: number;
    companyId: string;
    companyName: string;
    dateCreated: number;
    requestSocial: string;
    createdBy: string;
    idCreatedBy: string;
    facturaSuperlative: string;
    cmg: {
        cmg: string;
        desc: string;
        leader: string;
        level1: string;
        level1Cat: string;
        level2: string;
        level2Cat: string;
        Level3: string;
        level3Cat: string;
    };
    concept: string;
    entry: string;
    beneficiaryIsInc: boolean;
    beneficiary: {
        beneficiaryComercialName ? : string;
        legalName ? : string;
        beneficiaryFirstName ? : string;
        beneficiarySecondName ? : string;
        beneficiaryLastName ? : string;
        beneficiarySecondLastName ? : string;
        rfc: string;
        phone: string;
        email: string;
        adress: string;
        city: string;
        state: string;
        zip: string;
        bank: string;
        clabe: number;
        accountNumber: string;
        notes: string;
        id: string;
    };
    amount: number;
    fee: number;
    order: number;
    tax: number;
    total: number;
    notes: string;
    status: number;
    nameBeneficiary: string;
    paymentWithoutIva: number;
    messages?: {
        statusId: number;
        message: string;
        createDate: Date;
        liderStatusId: number;
    }[];
    attachments?:{
        fileName: string;
    }[];

    constructor(formData ? : any) {
        let data: any = !formData ? {} : formData;

        this.id = data.string || null;
        this.clientRequestId = data.clientRequestId || null;
        this.companyId = data.companyId || null;
        this.companyName = data.companyName || null;
        this.dateCreated = data.dateCreated || null;
        this.cmg = data.cmg || {};
        this.concept = data.concept || null;
        this.entry = data.entry || null;
        this.beneficiaryIsInc = data.beneficiaryIsInc || true;
        this.beneficiary = data.beneficiary || {};
        this.amount = data.amount || null;
        this.fee = data.fee || null;
        this.tax = data.tax || null;
        this.total = data.total || null;
        this.notes = data.notes || null;
        this.messages = data.messages || [];
        this.attachments = data.attachments || [];
        this.status = data.status || 1;
        this.nameBeneficiary = data.PaymentRequests || null;
        this.createdBy = data.createdBy || null;
        this.idCreatedBy = data.idCreatedBy || null;
        this.facturaSuperlative = data.facturaSuperlative || null;
        this.paymentWithoutIva = data.paymentWithoutIva || null;
    }
}